module.exports = __webpack_public_path__ + "img/search_advertising.e151a515.svg";